export const EXCHANGE = [
  { title: 'Exchange', img: '../assets/images/grid-item.svg', par: 'ExchangePar' },
  { title: 'Exchange', img: '../assets/images/grid-item.svg', par: 'ExchangePar' },
  { title: 'Exchange', img: '../assets/images/grid-item.svg', par: 'ExchangePar' },
  { title: 'Exchange', img: '../assets/images/grid-item.svg', par: 'ExchangePar' },
];
export { ReactComponent as DoubleArrows } from '../assets/images/svg/DoubleArrows.svg';
